import { Component, OnInit, OnDestroy } from '@angular/core';
import { IxellAPIService, IAdminBillingV1, LoginData, IMailDataV1, IActivationLight, IScaleFull, IScaleV1, IBillingV1, IBillingDetailV1, IAdresseV1, IProductV1 } from 'src/app/tools/api.service';
import { ActivationLight } from 'src/app/models/activationlight';
import { UntypedFormGroup, UntypedFormBuilder, UntypedFormControl, Validators } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute, Router } from '@angular/router';
import { Sort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { ErrorService } from 'src/app/tools/error.service';
import { HeaderService } from 'src/app/tools/header.service';
import { Constants } from 'src/app/entities/Constants';
import { Utils } from 'src/app/tools/utils';
import { Maildata } from '../../models/maildata';

export enum StatusType {
    ErrorBD = 0,
    Start = 1,
    InProgress = 2,
    Complete = 3,
    WaitLacourValidation = 4,
    Paid = 5,
    WaitForQuote = 6,
    StartColorUser = 7,
    InProgressColorUser = 8,
    DELETE_IXELLWEBLAB_ACTIVATION = 19,
    Sleepy = 42,
    Unknown = 99
}

export enum StatusBillingType {
    ErrorBd = -1,
    PENDING = 0,
    ABANDONED = 1,
    ACCEPTED = 2,
    AUTHORISED = 3,
    AUTHORISED_TO_VALIDATE = 4,
    CANCELLED = 5,
    CAPTURED = 6,
    CAPTURE_FAILED = 7,
    EXPIRED = 8,
    INITIAL = 9,
    NOT_CREATED = 10,
    REFUSED = 11,
    SUSPENDED = 12,
    UNDER_VEIRIFICATION = 13,
    WAITING_AUTHORISATION = 14,
    WAITING_ATHORISATION_TO_VALIDATE = 15,
    WAITING_AUTHORISATION_PAYMENT_BY_VIREMENT = 16,
    WAITING_QUOTE_VALIDATION = 17,
    QUOTE_VALIDATE = 18,
    DELETE_IXELLWEBLAB_BILLING = 19
}

export enum YesNo {
    ErrorBD = -1,
    No = 0,
    Yes = 1
}

export enum ProductType {
    ErrorBD = 0,
    Licence = 1,
    Support = 2,
    Cables = 3,
    Reseau = 4,
    Divers = 5
}

export enum ScaleSelect {
    ErrorBD = 0,
    IxellColorV1 = 1,
    IxellColorV2 = 2,
    IxellColorConnect = 4,
    IxellColorConnectPro = 8
}

@Component({
    selector: 'app-adminlacourLicence',
    templateUrl: './adminlacourLicence.component.html',
    styleUrls: ['./adminlacourLicence.component.scss']
})

export class AdminlacourLicenceComponent implements OnInit, OnDestroy {

    //displayedColumnsS1 = ["status", "activationID", "scaleCode", "activationDate", "ctcName", "edit"];
    displayedColumnsS2 = ["status", "activationID", "scaleCode", "activationDate", "ctcName", "userName", "companyUnisiteCode", "payorLoginUnisite", "companyPayorUnisiteCode", "sageCode", "edit", "mail", "sleepy", "detailRow"];
    displayedColumnsS3 = ["status", "activationID", "scaleCode", "activationDate", "ctcName", "userName", "companyUnisiteCode", "payorLoginUnisite", "companyPayorUnisiteCode", "sageCode", "waitPayment", "detailRow"];
    displayedColumnsS4 = ["status", "activationID", "scaleCode", "activationDate", "transDate", "ctcName", "userName", "companyUnisiteCode", "payorLoginUnisite", "companyPayorUnisiteCode", "sageCode", "paymentInfo", "detailRow"];
    displayedColumnsS5 = ["mouvement", "invoiceDate", "activationID", "scaleCode", "ctcName", "userName", "companyUnisiteCode", "payorLoginUnisite", "payorSocialReason", "companyPayorUnisiteCode", "activationCode", "sageCode", "facture", "finalEdit", "detailRow"];
    displayedColumns: string[];


    //displayedColumnsDetailS1 = [];
    //displayedColumnsDetail: string[]

    isBusy: boolean = false;
    conserverRecherche: boolean = true;
    valSearch: string = ""; 

    // Sub
    activationLightSub: any;
    activationInfoSub: any;
    payementInfoSub: any;
    unisiteSub: any;
    generateValidationSub: any;
    acceptPaymentSub: any;
    ctcConnectionSub: any;
    sleepySub: any;
    isCheckedSub: any;
    emailsSub: any;
    invoiceCodeSub: any;
    sageCodeSub: any;
    detailInfoSub: any;
    deleteSub: any;
    activationCodeSub: any;
    deleteScaleLicenceDatesSub: any;
    getAlternativeCTCSub: any;
    changeActivationCTCSub: any;
    changeActivationSubPropSub: any;
    getAllUsersSub: any;
    getAllCompaniesSub: any;
    changeActivationUserFullSub: any;
    changeActivationCompanyUserFullSub: any;
    duplicateActivationUserFullSub: any;
    duplicateActivationCompanyUserFullSub: any;
    getAllBalancesSub: any;
    sendMigrationRequestSub: any;
    resolveMigrationRequestSub: any;
    productSub: any;
    addBillingToActivationSub: any;
    emailSub: any;

    // Objets et tableaux
    activationLight: ActivationLight;
    allActivation: ActivationLight[] = [];
    activationStatus2: ActivationLight[] = [];
    activationStatus3: ActivationLight[] = [];
    activationStatus4: ActivationLight[] = [];
    activationStatus5: ActivationLight[] = [];
    activationLst: ActivationLight[] = [];
    activationSource: any;
    mailData: IMailDataV1;
    dataInfo: any[] = [];
    mailInfo: any[] = [];
    StatusType = StatusType;
    StatusBillingType = StatusBillingType;
    ProductType = ProductType;
    YesNo = YesNo;
    //activationDetailSource: any;
    scaleFull: IScaleFull;
    oldScaleFull: IScaleFull;
    // Messages/erreurs
    info = false;
    successMsgUnisite = false;
    errorMail = false;
    successMsgDossier = false;
    errorPayorUnisite = false;
    errorUserUnisite = false;
    errorRightUnisite = false;
    editInvoice: boolean = false;
    editUnisite: boolean = false;
    errorCtcAccount: boolean = false;
    errorCtcInput: boolean = false;
    unisiteError: boolean = false;
    unisiteLoginError: boolean = false;
    unisiteCodeError: boolean = false;
    sageError: boolean = false;
    // titre = "Les codes n'ont pas été remplis";

    actualId: number;
    order: IAdminBillingV1;
    orderTotal = 0;

    // js pour les tab
    actualtab = '';
    actualpane = '';

    status: string;
    checked: boolean = false;
    noMail: boolean = false;
    confirmationModalCB: any = undefined;
    availableBalances: IScaleV1[] = [];
    pendingMigration: number = 0;
    badCode: boolean = false;
    activationToAddBillingTo: number = 0;
    usableStatuses: any[] = this.getUsableStatuses();
    countries: any = Constants.countries;
    tvaCkeck: boolean = false;
    tauxTva: number = 0;
    noMailOnNewBilling: boolean = false;
    products: IProductV1[] = [];

    temp: LoginData = new LoginData();


    languages = [
        { name: "German", txt: "scaleform.allemand" },
        { name: "English", txt: "scaleform.anglais" },
        { name: "Spanish", txt: "scaleform.espagnol" },
        { name: "French", txt: "scaleform.français" },
        { name: "Italian", txt: "scaleform.italien" },
        { name: "Dutch", txt: "scaleform.neerlandais" },
        { name: "Romanian", txt: "scaleform.roumain" },
        { name: "Portuguese", txt: "scaleform.portugais" },
        { name: "Polish", txt: "scaleform.polonais" },
        { name: "Turkish", txt: "scaleform.turc" }
    ];

    // Formulaires
    unisiteUser = new UntypedFormGroup({
        loginUnisiteUser: new UntypedFormControl('', [Validators.required])
    });
    unisitePayor = new UntypedFormGroup({
        loginUnisitePayor: new UntypedFormControl('', [Validators.required])
    });
    unisiteCompany = new UntypedFormGroup({
        loginUnisiteUserCompany: new UntypedFormControl('', [Validators.required])
    });
    unisiteCompanyPayor = new UntypedFormGroup({
        loginUnisiteUserCompanyPayor: new UntypedFormControl('', [Validators.required])
    });
    passwordUser = new UntypedFormGroup({
        passwordUser: new UntypedFormControl('', [Validators.required])
    });
    passwordPayor = new UntypedFormGroup({
        passwordPayor: new UntypedFormControl('', [Validators.required])
    });
    sageForm = new UntypedFormGroup({
        sageCode: new UntypedFormControl('', [Validators.required])
    });
    invoiceForm = new UntypedFormGroup({
        invoiceCode: new UntypedFormControl('', [Validators.required])
    });
    newCtc = new UntypedFormGroup({
        ctcLogin: new UntypedFormControl('', [Validators.required]),
        ctcPassword: new UntypedFormControl('', [Validators.required]),
        ctcLanguage: new UntypedFormControl('', [Validators.required])
    });
    migration = new UntypedFormGroup({
        balance: new UntypedFormControl(null, [Validators.required]),
        activations: new UntypedFormControl([], [Validators.required]),
    });
    migrationConfirm = new UntypedFormGroup({
        code: new UntypedFormControl(null, [Validators.required]),
    });
    addBillingForm = new UntypedFormGroup({
        licenseAmount: new UntypedFormControl(1, [Validators.required]),
        status: new UntypedFormControl(StatusBillingType.WAITING_AUTHORISATION_PAYMENT_BY_VIREMENT, [Validators.required]),
        isCb: new UntypedFormControl(false, [Validators.required]),
        unisiteCode: new UntypedFormControl(null, [Validators.required]),
        login: new UntypedFormControl(null, [Validators.required]),

        socialReasonFact: new UntypedFormControl('', [Validators.required]),
        addressFact: new UntypedFormControl('', [Validators.required]),
        postalCodeFact: new UntypedFormControl('', [Validators.required]),
        cityFact: new UntypedFormControl('', [Validators.required]),
        countryFFact: new UntypedFormControl('', [Validators.required]),
        siret: new UntypedFormControl(''),
        tva: new UntypedFormControl(''),

        socialReason: new UntypedFormControl('', [Validators.required]),
        address: new UntypedFormControl('', [Validators.required]),
        postalCode: new UntypedFormControl('', [Validators.required]),
        city: new UntypedFormControl('', [Validators.required]),
        countryF: new UntypedFormControl('', [Validators.required]),
        island: new UntypedFormControl(false),

        mail: new UntypedFormControl('', [Validators.required, Validators.email]),
    });

    constructor(private api: IxellAPIService, private errorService: ErrorService, private formBuilder: UntypedFormBuilder, private headerService: HeaderService, private _snackBar: MatSnackBar, private route: ActivatedRoute, private router: Router) { }

    ngOnInit() {
        Utils.deleteStorageData();
        this.getData("2");
        this.getBalances();
        this.getProduits();

        let code = this.route.snapshot.paramMap.get('tab');
        if (code) {
            sessionStorage.setItem("adminCode", code);
            this.router.navigate(["login"]);
        } else {
            let adminCode: string = sessionStorage.getItem("adminCode");
            if (adminCode) {
                sessionStorage.removeItem("adminCode");
                this.headerService.verifyRole();
            }
        }
        // Pour afficher la flèche de retour
        this.headerService.changeCanBack(true);

        this.actualtab = "nav-profile-tab";
        this.actualpane = "nav-profile";

        this.headerService.changeTitle("IxellWebLab");
        this.headerService.changeLogo(null);
    }

    ngOnDestroy() {
        if (this.activationLightSub != null) this.activationLightSub.unsubscribe();
        if (this.activationInfoSub != null) this.activationInfoSub.unsubscribe();
        if (this.unisiteSub != null) this.unisiteSub.unsubscribe();
        if (this.payementInfoSub != null) this.payementInfoSub.unsubscribe();
        if (this.generateValidationSub != null) this.generateValidationSub.unsubscribe();
        if (this.acceptPaymentSub != null) this.acceptPaymentSub.unsubscribe();
        if (this.ctcConnectionSub != null) this.ctcConnectionSub.unsubscribe();
        if (this.isCheckedSub != null) this.isCheckedSub.unsubscribe();
        if (this.emailsSub != null) this.emailsSub.unsubscribe();
        if (this.invoiceCodeSub != null) this.invoiceCodeSub.unsubscribe();
        if (this.sleepySub != null) this.sleepySub.unsubscribe();
        if (this.sageCodeSub != null) this.sageCodeSub.unsubscribe();
        if (this.detailInfoSub != null) this.detailInfoSub.unsubscribe();
        if (this.deleteSub != null) this.deleteSub.unsubscribe();
        if (this.activationCodeSub != null) this.activationCodeSub.unsubscribe();
        if (this.deleteScaleLicenceDatesSub != null) this.deleteScaleLicenceDatesSub.unsubscribe();
        if (this.getAlternativeCTCSub != null) this.getAlternativeCTCSub.unsubscribe();
        if (this.changeActivationCTCSub != null) this.changeActivationCTCSub.unsubscribe();
        if (this.changeActivationSubPropSub != null) this.changeActivationSubPropSub.unsubscribe();
        if (this.getAllUsersSub != null) this.getAllUsersSub.unsubscribe();
        if (this.getAllCompaniesSub != null) this.getAllCompaniesSub.unsubscribe();
        if (this.changeActivationUserFullSub != null) this.changeActivationUserFullSub.unsubscribe();
        if (this.changeActivationCompanyUserFullSub != null) this.changeActivationCompanyUserFullSub.unsubscribe();
        if (this.duplicateActivationUserFullSub != null) this.duplicateActivationUserFullSub.unsubscribe();
        if (this.duplicateActivationCompanyUserFullSub != null) this.duplicateActivationCompanyUserFullSub.unsubscribe();
        if (this.getAllBalancesSub != null) this.getAllBalancesSub.unsubscribe();
        if (this.sendMigrationRequestSub != null) this.sendMigrationRequestSub.unsubscribe();
        if (this.resolveMigrationRequestSub != null) this.resolveMigrationRequestSub.unsubscribe();
        if (this.productSub != null) this.productSub.unsubscribe();
        if (this.addBillingToActivationSub != null) this.addBillingToActivationSub.unsubscribe();
        if (this.emailSub != null) this.emailSub.unsubscribe();
    }

    applyFilter(filterValue: string) {
        this.activationSource.filter = filterValue.trim().toLowerCase();
    }

    onIsCheckedChange(id: number) {
        this.isCheckedSub = this.api.isCheckedDossier(id).subscribe(data => {
            if (this.isCheckedSub != null) this.isCheckedSub.unsubscribe();
        }, error => {
            console.log(error);
            if (this.isCheckedSub != null) this.isCheckedSub.unsubscribe();
        })
    }
    openSnackBar(message: string, action: string) {
        // Petite notification
        this._snackBar.open(message, action, {
            duration: 5000,
            panelClass: ['blue-snackbar']
        });
    }

    getData(status: string) {
        this.status = status;
        this.activationStatus2 = [];
        this.activationStatus3 = [];
        this.activationStatus4 = [];
        this.activationStatus5 = [];
        this.activationLst = [];
        this.activationSource = null;
        this.allActivation = [];
        var transStatusRejected = [1, 5, 8, 11, 19]; // 1 : ABANDONED, 5 : CANCELLED, 8 : EXPIRED, 11 : REFUSED, 19 : DELETE_IXELLWEBLAB_BILLING
        this.activationLightSub = this.api.allActivationBilling().subscribe(data => {
            if (data != null) {
                data.forEach(element => {
                    // Ajoute toutes les activations au tableau
                    this.allActivation.push(ActivationLight.parseToActivationLight(element));
                    if (element.activationStatus == 1 || element.activationStatus == 2 || element.activationStatus == 7 || element.activationStatus == 8)
                        this.activationStatus2.push(ActivationLight.parseToActivationLight(element));
                    if (element.activationStatus == 3)
                        this.activationStatus3.push(ActivationLight.parseToActivationLight(element));
                    if (element.activationStatus == 4) {
                        if (transStatusRejected.indexOf(element.transStatus) == -1) {
                            this.activationStatus4.push(ActivationLight.parseToActivationLight(element));
                        }
                    }
                    if (element.activationStatus == 5) {
                        if (!element.invoiceDate)
                            element.invoiceDate = element.transDate;
                        if (element.transStatus == 2)
                            this.activationStatus5.push(ActivationLight.parseToActivationLight(element));
                        else {
                            if (transStatusRejected.indexOf(element.transStatus) == -1) {
                                this.activationStatus4.push(ActivationLight.parseToActivationLight(element));
                            }
                        }
                    }
                    switch (status) {
                        case "2":
                            this.activationStatus2.sort((a, b) => { return Constants.compare(a.activationID, b.activationID, true); })
                            this.activationLst = this.activationStatus2;
                            this.activationSource = new MatTableDataSource(this.activationStatus2);
                            this.displayedColumns = this.displayedColumnsS2;
                            break;
                        case "3":
                            this.activationStatus3.sort((a, b) => { return Constants.compare(a.activationID, b.activationID, true); })
                            this.activationLst = this.activationStatus3;
                            this.activationSource = new MatTableDataSource(this.activationStatus3);
                            this.displayedColumns = this.displayedColumnsS3;
                            break;
                        case "4":
                            this.activationStatus4.sort((a, b) => { return Constants.compare(a.activationID, b.activationID, true); })
                            this.activationLst = this.activationStatus4;
                            this.activationSource = new MatTableDataSource(this.activationStatus4);
                            this.displayedColumns = this.displayedColumnsS4;
                            break;
                        case "5":
                            this.activationStatus5.sort((a, b) => { return Constants.compareDate(a.invoiceDate, b.invoiceDate, true); })
                            this.displayedColumns = this.displayedColumnsS5;
                            this.activationLst = this.activationStatus5;
                            this.activationSource = new MatTableDataSource(this.activationStatus5);
                            break;
                    }
                });

                if (this.conserverRecherche) {
                    this.applyFilter(this.valSearch);
                } else {
                    this.valSearch = "";
                }
            }
            if (this.activationLightSub != null) this.activationLightSub.unsubscribe();
        }, error => {
            this.errorService.setErrorLog("API", error.status.toString() + " " + error.message, "allActivation", new Date().toString());
            if (this.activationLightSub != null) this.activationLightSub.unsubscribe();
        });
    }

    toggleTab(status: string, pane: string, tab: string) {
        switch (status) {
            case "1":
            case "2":
                this.getData("2");
                break;
            case "3":
                this.getData("3");
                break;
            case "4":
                this.getData("4");
                break;
            case "5":
                this.getData("5");
                break;
        }
        document.getElementById(this.actualtab).classList.remove("active");
        document.getElementById(tab).classList.add("active");
        this.actualpane = pane;
        this.actualtab = tab;
    }

    getBalances() {
        this.getAllBalancesSub = this.api.getAllBalances().subscribe(data => {
            this.availableBalances = data;
            if (this.getAllBalancesSub != null) this.getAllBalancesSub.unsubscribe();
        }, error => {

            if (this.getAllBalancesSub != null) this.getAllBalancesSub.unsubscribe();
        });
    }

    getProduits() {
        this.productSub = this.api.selectProducts().subscribe(data => {
            this.products = data.filter(product => product.productID === 3);
            if (this.productSub != null) this.productSub.unsubscribe();
        }, error => {
            if (this.productSub != null) this.productSub.unsubscribe();
        });
    }

    displayInfoActivation(id: any, edit: any, idBilling: number) {
        if (edit == 1) {
            this.editUnisite = true;
            this.editInvoice = false;
        } else if (edit == 2) {
            this.editUnisite = false;
            this.editInvoice = true;
        }
        // Récupère l'id en string, la passe en int
        this.actualId = id;
        var idInt = parseInt(id, 10);
        this.activationInfoSub = this.api.infoActivation(idInt, idBilling).subscribe(data => {
            if (data) {
                // Ajoute l'activation dans le tableau, affiche la modal
                this.dataInfo = [];
                this.dataInfo = data;
                let modal = document.getElementById("unisiteModal");
                modal.style.display = "block";
                if (this.dataInfo[0].activStatut == 7 || this.dataInfo[0].activStatut == 8) {
                    this.unisiteUser.controls['loginUnisiteUser'].setValidators([]);
                    this.unisitePayor.controls['loginUnisitePayor'].setValidators([]);
                }
                else {
                    this.unisiteUser.controls['loginUnisiteUser'].setValidators([Validators.required]);
                    this.unisitePayor.controls['loginUnisitePayor'].setValidators([Validators.required]);
                }
                // Remplis les input si il y a déjà une valeur
                let index = this.allActivation.findIndex(i => i.activationID == this.actualId);
                let indexb = this.allActivation.findIndex(i => i.billingID == idBilling);
                this.unisiteUser.setValue({
                    loginUnisiteUser: this.allActivation[index].userLoginUnisite,
                })
                this.unisitePayor.setValue({
                    loginUnisitePayor: this.allActivation[index].payorLoginUnisite,
                })
                this.unisiteCompany.setValue({
                    loginUnisiteUserCompany: this.allActivation[index].companyUnisiteCode,
                })
                this.unisiteCompanyPayor.setValue({
                    loginUnisiteUserCompanyPayor: this.allActivation[index].companyPayorUnisiteCode,
                })
                this.sageForm.setValue({
                    sageCode: this.allActivation[index].sageCode,
                })
                this.invoiceForm.setValue({
                    invoiceCode: this.allActivation[indexb].invoiceCode,
                })
            }
            if (this.activationInfoSub != null) this.activationInfoSub.unsubscribe();
        }, error => {
            this.errorService.setErrorLog("IHM", error.status.toString() + " " + error.message, "infoActivation, id = " + id, new Date().toString());
            console.log(error);
            if (this.activationInfoSub != null) this.activationInfoSub.unsubscribe();
        })
    }

    displayMailInfo(id: any, noMail: boolean = false) {
        this.noMail = noMail;

        // Récupère l'id en string, la passe en int
        this.actualId = id;
        var idInt = parseInt(id, 10);
        this.activationInfoSub = this.api.infoActivation(idInt, 0).subscribe(data => {
            // Ajoute l'activation dans le tableau, affiche la modal
            this.mailInfo = [];
            this.mailInfo = data;
            if (this.mailInfo[0].activStatut == 7 || this.mailInfo[0].activStatut == 8) {
                this.passwordUser.controls['passwordUser'].setValidators([]);
                this.passwordUser.controls['passwordUser'].markAsTouched();
                this.passwordPayor.controls['passwordPayor'].setValidators([]);
                this.passwordPayor.controls['passwordPayor'].markAsTouched();
                this.passwordPayor.updateValueAndValidity();
                this.passwordUser.updateValueAndValidity();
            }
            else {
                this.passwordUser.controls['passwordUser'].setValidators([Validators.required]);
                this.passwordPayor.controls['passwordPayor'].setValidators([Validators.required]);
            }
            let modal = document.getElementById("mailModal");
            modal.style.display = "block";
            if (this.activationInfoSub != null) this.activationInfoSub.unsubscribe();
        }, error => {
            this.errorService.setErrorLog("IHM", error.status.toString() + " " + error.message, "infoActivation, id = " + idInt, new Date().toString());
            console.log(error);
            if (this.activationInfoSub != null) this.activationInfoSub.unsubscribe();
        })
    }

    displayPayementInfo(id: any) {
        // Affiche la modal
        let modal = document.getElementById("payementModal");
        modal.style.display = "block";
        this.payementInfoSub = this.api.displayBillDetails(id).subscribe(data => {
            this.order = data;
            if (data != null) {
                this.orderTotal = 0;
                // Si il y a des éléments dans la commande
                this.order.lstBillDetails.forEach(element => {
                    // Calcul le total de cette commande
                    this.orderTotal += element.product.amountP * element.qty;
                });
                this.orderTotal = this.orderTotal + (this.orderTotal * this.order.tva) / 100;
            } else {
                this.orderTotal = 0;
            }
            if (this.payementInfoSub != null) this.payementInfoSub.unsubscribe();
        }, error => {
            this.errorService.setErrorLog("IHM", error.status.toString() + " " + error.message, "displayBillDetails, id = " + id, new Date().toString());
            if (this.payementInfoSub != null) this.payementInfoSub.unsubscribe();
            console.log(error);
        });
    }

    displayInvoiceModal(id: any, billingID: number) {
        this.actualId = id;
        var idInt = parseInt(id, 10);
        this.activationInfoSub = this.api.infoActivation(idInt, billingID).subscribe(data => {
            if (data) {
                // Ajoute l'activation dans le tableau, affiche la modal
                this.dataInfo = [];
                this.dataInfo = data;
                let modal = document.getElementById("invoiceModal");
                modal.style.display = "block";
            }
            if (this.activationInfoSub != null) this.activationInfoSub.unsubscribe();
        }, error => {
            this.errorService.setErrorLog("IHM", error.status.toString() + " " + error.message, "infoActivation, id = " + id, new Date().toString());
            console.log(error);
            if (this.activationInfoSub != null) this.activationInfoSub.unsubscribe();
        })
    }

    changeCtc(event: any, ctcLogin: any, id: any) {
        if (event.ctrlKey) {
            this.actualId = id;
            var idInt = parseInt(id, 10);
            this.activationInfoSub = this.api.infoActivation(idInt, 0).subscribe(data => {
                if (data) {
                    // Ajoute l'activation dans le tableau, affiche la modal
                    this.dataInfo = [];
                    this.dataInfo = data;
                    let modal = document.getElementById("ctcModal");
                    modal.style.display = "block";
                }
                if (this.activationInfoSub != null) this.activationInfoSub.unsubscribe();
            }, error => {
                this.errorService.setErrorLog("IHM", error.status.toString() + " " + error.message, "infoActivation, id = " + id, new Date().toString());
                console.log(error);
                if (this.activationInfoSub != null) this.activationInfoSub.unsubscribe();
            })
        }
    }

    refreshActivationList(status: string) {
        this.activationStatus2 = [];
        this.activationStatus3 = [];
        this.activationStatus4 = [];
        this.activationStatus5 = [];
        this.allActivation.forEach(element => {
            if (element.activationStatus == 1 || element.activationStatus == 2)
                this.activationStatus2.push(element);
            if (element.activationStatus == 3)
                this.activationStatus3.push(element);
            if (element.activationStatus == 4)
                this.activationStatus4.push(element);
            if (element.activationStatus == 5) {
                if (element.transStatus == 2)
                    this.activationStatus5.push(element);
                else
                    this.activationStatus4.push(element);
            }
        });
        switch (status) {
            case "1":
            case "2":
                this.activationSource = new MatTableDataSource(this.activationStatus2.slice());
                this.activationLst = this.activationStatus2.slice();
                this.displayedColumns = this.displayedColumnsS2;
                break;
            case "3":
                this.activationSource = new MatTableDataSource(this.activationStatus3.slice());
                this.activationLst = this.activationStatus3.slice();
                this.displayedColumns = this.displayedColumnsS3;
                break;
            case "4":
                this.activationSource = new MatTableDataSource(this.activationStatus4.slice());
                this.activationLst = this.activationStatus4.slice();
                this.displayedColumns = this.displayedColumnsS4;
                break;
            case "5":
                this.activationSource = new MatTableDataSource(this.activationStatus5.slice());
                this.activationLst = this.activationStatus5.slice();
                this.displayedColumns = this.displayedColumnsS5;
                break;
        }
    }

    refreshTab() {
        let tab = this.actualtab;
        switch (tab) {
            case "nav-profile-tab":
                this.getData("2");
                break;
            case "nav-contact-tab":
                this.getData("3");
                break;
            case "nav-stat4-tab":
                this.getData("4");
                break;
            case "nav-stat5-tab":
                this.getData("5");
                break;
        }
    }

    closeModal(name: string) {
        switch (name) {
            case "mailModal":
                let mailModal = document.getElementById("mailModal");
                mailModal.style.display = "none";
                this.passwordUser.reset();
                this.passwordPayor.reset();
                this.errorMail = false;
                break;
            default:
                let modal = document.getElementById(name);
                modal.style.display = "none";
                break;
        }
    }

    sendUnisiteCode(close: boolean, activationId: string, noMail: boolean = false) {
        // Statut 1 - Envoie les codes Unisites
        // Si utilisateur = payeur
        if (this.dataInfo[0].userfirstname == this.dataInfo[0].payorfirstname && this.dataInfo[0].username == this.dataInfo[0].payorname) {
            this.unisiteError = false;
            if (this.unisiteUser.status == "VALID" && this.unisiteCompany.status == "VALID" && this.sageForm.status == "VALID") {
                // Remplis dans les deux utilisateurs/payeurs les logins
                this.unisiteSub = this.api.addUnisiteLogs(this.actualId, this.unisiteUser.value.loginUnisiteUser ? this.unisiteUser.value.loginUnisiteUser.trim() : null, this.unisiteUser.value.loginUnisiteUser ? this.unisiteUser.value.loginUnisiteUser.trim() : null,
                    this.unisiteCompany.value.loginUnisiteUserCompany.trim(), this.unisiteCompany.value.loginUnisiteUserCompany.trim(), this.sageForm.value.sageCode.trim()).subscribe(data => {
                        let index = this.allActivation.findIndex(i => i.activationID == this.actualId);
                        if (index > -1) {
                            this.allActivation[index].userLoginUnisite = this.unisiteUser.value.loginUnisiteUser;
                            this.allActivation[index].payorLoginUnisite = this.unisiteUser.value.loginUnisiteUser;
                            this.allActivation[index].companyUnisiteCode = this.unisiteCompany.value.loginUnisiteUserCompany;
                            this.allActivation[index].companyPayorUnisiteCode = this.unisiteCompany.value.loginUnisiteUserCompany;
                            this.allActivation[index].sageCode = this.sageForm.value.sageCode;
                            this.allActivation[index].invoiceCode = this.unisiteCompanyPayor.value.invoiceCode;
                            //this.refreshActivationList("2");
                            //this.refreshTab();

                        }
                        if (data == true) {
                            if (close)
                                this.closeModal("unisiteModal");

                            if (activationId != null) {
                                this.displayMailInfo(activationId, noMail);
                            }

                            this.openSnackBar("Prêt pour l'envoi", "Fermer");
                            // pour afficher l'envoie de mail
                            this.allActivation[index].activationStatus = 2;
                        }
                        if (this.unisiteSub != null) this.unisiteSub.unsubscribe();
                        this.refreshTab();
                    }, error => {
                        this.errorService.setErrorLog("IHM", error.status.toString() + " " + error.message, "addUnisiteLogs, id = " + activationId, new Date().toString());
                        console.log(error);
                        if (this.unisiteSub != null) this.unisiteSub.unsubscribe();
                    })
            } else {
                this.unisiteError = true;
                if (this.sageForm.status == "INVALID")
                    this.sageError = true;
                else
                    this.sageError = false;
                if (this.unisiteUser.status == "INVALID")
                    this.unisiteLoginError = true;
                else
                    this.unisiteLoginError = false;
                if (this.unisiteCompany.status == "INVALID")
                    this.unisiteCodeError = true;
                else
                    this.unisiteCodeError = false;
            }
        } else {
            // Si utilisateur != payeur
            if (this.unisitePayor.status == "VALID" && this.unisiteUser.status == "VALID" && this.unisiteCompany.status == "VALID"
                && this.unisiteCompanyPayor.status == "VALID" && this.sageForm.status == "VALID") {
                this.unisiteSub = this.api.addUnisiteLogs(this.actualId, this.unisiteUser.value.loginUnisiteUser ? this.unisiteUser.value.loginUnisiteUser.trim() : null, this.unisitePayor.value.loginUnisitePayor ? this.unisitePayor.value.loginUnisitePayor.trim() : null,
                    this.unisiteCompany.value.loginUnisiteUserCompany.trim(), this.unisiteCompanyPayor.value.loginUnisiteUserCompanyPayor.trim(), this.sageForm.value.sageCode.trim()).subscribe(data => {
                        let index = this.allActivation.findIndex(i => i.activationID == this.actualId);
                        if (index > -1) {
                            this.allActivation[index].userLoginUnisite = this.unisiteUser.value.loginUnisiteUser;
                            this.allActivation[index].payorLoginUnisite = this.unisitePayor.value.loginUnisitePayor;
                            this.allActivation[index].companyUnisiteCode = this.unisiteCompany.value.loginUnisiteUserCompany;
                            this.allActivation[index].companyPayorUnisiteCode = this.unisiteCompanyPayor.value.loginUnisiteUserCompanyPayor;
                            this.allActivation[index].sageCode = this.unisiteCompanyPayor.value.sageCode;
                            this.allActivation[index].invoiceCode = this.unisiteCompanyPayor.value.invoiceCode;
                        }
                        if (data == true) {
                            if (close)
                                this.closeModal("unisiteModal");
                            if (activationId != null)
                                this.displayMailInfo(activationId);
                            this.openSnackBar("Prêt pour l'envoi", "Fermer");
                            // pour afficher l'envoie de mail
                            this.allActivation[index].activationStatus = 2;
                        }
                        if (this.unisiteSub != null) this.unisiteSub.unsubscribe();
                        this.refreshTab();
                    }, error => {
                        this.errorService.setErrorLog("IHM", error.status.toString() + " " + error.message, "addUnisiteLogs, id = " + activationId, new Date().toString());
                        if (this.unisiteSub != null) this.unisiteSub.unsubscribe();
                        console.log(error);
                    })
            } else {
                this.unisiteError = true;
                if (this.sageForm.status == "INVALID")
                    this.sageError = true;
                else
                    this.sageError = false;
                if (this.unisiteUser.status == "INVALID" || this.unisitePayor.status == "INVALID")
                    this.unisiteLoginError = true;
                else
                    this.unisiteLoginError = false;
                if (this.unisiteCompany.status == "INVALID" || this.unisiteCompanyPayor.status == "INVALID")
                    this.unisiteCodeError = true;
                else
                    this.unisiteCodeError = false;
            }
        }
        //this.refreshActivationList("2");
        //this.refreshTab();
    }

    completeWithoutMail(data: any) {
        if (!this.isBusy) {
            if (this.mailInfo[0].activStatut == 7 || this.mailInfo[0].activStatut == 8) {
                this.passwordUser.controls['passwordUser'].setValidators([]);
                this.passwordUser.controls['passwordUser'].markAsTouched();
                this.passwordPayor.controls['passwordPayor'].setValidators([]);
                this.passwordPayor.controls['passwordPayor'].markAsTouched();
                this.passwordUser.controls['passwordUser'].updateValueAndValidity();
                this.passwordPayor.controls['passwordPayor'].updateValueAndValidity();
            }
            this.isBusy = true;
            // Statut 2 - Envoie du nouveau statut
            this.errorMail = false;
            if (this.passwordUser.status == "VALID") {
                if (this.passwordPayor.status == "INVALID") {
                    this.passwordPayor.value.passwordPayor = this.passwordUser.value.passwordUser;
                }


                this.mailData = new IMailDataV1();
                this.mailData.activationId = this.actualId;
                this.mailData.activStatut = Number.parseInt(data.activStatut);
                this.mailData.userLoginUnisite = data.userloginunisite;
                this.mailData.userPwdUnisite = this.passwordUser.value.passwordUser;
                this.mailData.userCompany = data.companyunisitecode;
                this.mailData.payorLoginUnisite = data.payorloginunisite;
                this.mailData.payorPwdUnisite = this.passwordPayor.value.passwordPayor;
                this.mailData.payorCompany = data.companyPayorunisitecode;

                this.emailsSub = this.api.completeWithoutMail(this.mailData).subscribe(data => {
                    this.errorMail = false;
                    let index = this.allActivation.findIndex(i => i.activationID == this.actualId);
                    if (index > -1) {
                        if (data == "true") {
                            this.closeModal("mailModal");
                            this.errorPayorUnisite = false;
                            this.errorUserUnisite = false;
                            this.openSnackBar("Dossier validé!", "Fermer");
                            this.allActivation[index].activationStatus = 3;
                            this.passwordUser.setValue({ passwordUser: "" });
                            this.passwordPayor.setValue({ passwordPayor: "" });
                        } else if (data == "payorFalse") {
                            this.errorPayorUnisite = true;
                        } else if (data == "userFalse") {
                            this.errorUserUnisite = true;
                        } else if (data == "rightFalse") {
                            this.errorRightUnisite = true;
                        }
                        this.isBusy = false;
                        this.refreshTab();
                    }
                    if (this.emailsSub != null) this.emailsSub.unsubscribe();
                }, error => {
                    this.errorService.setErrorLog("IHM", error.status.toString() + " " + error.message, "completeWithoutMail " + JSON.stringify(this.mailData), new Date().toString());
                    console.log(error);
                    if (this.emailsSub != null) this.emailsSub.unsubscribe();
                    if (error.status == 500) {
                        this.errorMail = true;
                    }
                    this.isBusy = false;
                });
            }
            else {
                this.isBusy = false;
            }
        }
    }

    sendMails(data: any) {
        if (!this.isBusy) {
            if (this.mailInfo[0].activStatut == 7 || this.mailInfo[0].activStatut == 8) {
                this.passwordUser.controls['passwordUser'].setValidators([]);
                this.passwordUser.controls['passwordUser'].markAsTouched();
                this.passwordPayor.controls['passwordPayor'].setValidators([]);
                this.passwordPayor.controls['passwordPayor'].markAsTouched();
                this.passwordUser.controls['passwordUser'].updateValueAndValidity();
                this.passwordPayor.controls['passwordPayor'].updateValueAndValidity();
            }
            this.isBusy = true;
            // Statut 2 - Envoie des mails
            this.errorMail = false;
            if (this.passwordUser.status == "VALID") {
                if (this.passwordPayor.status == "INVALID") {
                    this.passwordPayor.value.passwordPayor = this.passwordUser.value.passwordUser;
                }


                this.mailData = new IMailDataV1();
                this.mailData.activationId = this.actualId;
                this.mailData.activStatut = Number.parseInt(data.activStatut);
                this.mailData.scaleCode = data.scalecode;
                this.mailData.userMail = data.usermail;
                this.mailData.userLanguage = data.userlanguage;
                this.mailData.userFirstname = data.userfirstname;
                this.mailData.userName = data.username;
                this.mailData.userLoginUnisite = data.userloginunisite;
                this.mailData.userPwdUnisite = this.passwordUser.value.passwordUser;
                this.mailData.userCompany = data.companyunisitecode;
                this.mailData.payorMail = data.payormail;
                this.mailData.payorLanguage = data.payorlanguage;
                this.mailData.payorFirstname = data.payorfirstname;
                this.mailData.payorName = data.payorname;
                this.mailData.payorLoginUnisite = data.payorloginunisite;
                this.mailData.payorPwdUnisite = this.passwordPayor.value.passwordPayor;
                this.mailData.payorCompany = data.companyPayorunisitecode;
                this.mailData.ctcMail = data.ctcmail;
                this.mailData.ctcLanguage = data.ctclanguage;
                this.mailData.ctcFirstname = data.ctcfirstname;
                this.mailData.ctcName = data.ctcname;

                this.emailsSub = this.api.sendEmails(this.mailData).subscribe(data => {
                    this.errorMail = false;
                    let index = this.allActivation.findIndex(i => i.activationID == this.actualId);
                    if (index > -1) {
                        if (data == "true") {
                            this.closeModal("mailModal");
                            this.errorPayorUnisite = false;
                            this.errorUserUnisite = false;
                            this.openSnackBar("Mails bien envoyés!", "Fermer");
                            this.allActivation[index].activationStatus = 3;
                            this.passwordUser.setValue({ passwordUser: "" });
                            this.passwordPayor.setValue({ passwordPayor: "" });
                        } else if (data == "payorFalse") {
                            this.errorPayorUnisite = true;
                        } else if (data == "userFalse") {
                            this.errorUserUnisite = true;
                        } else if (data == "rightFalse") {
                            this.errorRightUnisite = true;
                        }
                        this.isBusy = false;
                        this.refreshTab();
                    }
                    if (this.emailsSub != null) this.emailsSub.unsubscribe();
                }, error => {
                    this.errorService.setErrorLog("IHM", error.status.toString() + " " + error.message, "sendEmails " + JSON.stringify(this.mailData), new Date().toString());
                    console.log(error);
                    if (this.emailsSub != null) this.emailsSub.unsubscribe();
                    if (error.status == 500) {
                        this.errorMail = true;
                    }
                    this.isBusy = false;
                });
            }
            else {
                this.isBusy = false;
            }
        }
    }

    validatePayement(id: number, idBilling: number, noMail: boolean = false) {
        this.acceptPaymentSub = this.api.acceptPayment(idBilling).subscribe(data => {
            if (data == true) {
                let index = this.allActivation.findIndex(i => i.billingID == idBilling);
                this.allActivation[index].activationStatus = 5;
                this.allActivation[index].transStatus = 2;
                this.generateValidationSub = this.api.validationCommande(id, new Date, false, idBilling, noMail).subscribe(data => {
                    if (data) {
                        this.allActivation[index].activationCode = data;
                        this.closeModal("payementModal");
                        this.openSnackBar("Paiement bien enregistré!", "Fermer");
                        this.toggleTab('5', 'nav-stat5', 'nav-stat5-tab');
                    }
                }, error => {
                    this.errorService.setErrorLog("IHM", error.status.toString() + " " + error.message, "ValidationCommande", new Date().toString());
                    if (this.generateValidationSub != null) this.generateValidationSub.unsubscribe();
                    console.log(error);
                })
            } else {
                // Gestion d'erreurs à faire
            }
            if (this.acceptPaymentSub != null) this.acceptPaymentSub.unsubscribe();
        }, error => {
            this.errorService.setErrorLog("IHM", error.status.toString() + " " + error.message, "acceptPayment", new Date().toString());
            if (this.acceptPaymentSub != null) this.acceptPaymentSub.unsubscribe();
            console.log(error);
        })
    }

    sendInvoiceCode(id: number) {
        let index = this.allActivation.findIndex(i => i.activationID == this.actualId);
        let indexb = this.allActivation.findIndex(i => i.billingID == id);

        if (this.invoiceForm.status == "VALID") {
            this.invoiceCodeSub = this.api.setInvoiceCode(this.invoiceForm.value.invoiceCode, id).subscribe(data => {
                if (data == true) {
                    this.allActivation[indexb].invoiceCode = this.invoiceForm.value.invoiceCode;
                    this.closeModal("unisiteModal");
                    this.openSnackBar("Numéro de facture bien rentré", "Fermer");
                }
                if (this.sageForm.status != "VALID") {
                    this.toggleTab('5', 'nav-stat5', 'nav-stat5-tab');
                }
                if (this.invoiceCodeSub != null) this.invoiceCodeSub.unsubscribe();
            }, error => {
                console.log(error);
                if (this.invoiceCodeSub != null) this.invoiceCodeSub.unsubscribe();
            });
        }
        if (this.sageForm.status == "VALID") {
            this.sageCodeSub = this.api.setSageCode(this.sageForm.value.sageCode, this.actualId, id).subscribe(data => {
                if (data == true) {
                    this.allActivation[index].sageCode = this.sageForm.value.sageCode;
                    this.closeModal("unisiteModal");
                    this.openSnackBar("Codes bien rentrés", "Fermer");
                }
                this.toggleTab('5', 'nav-stat5', 'nav-stat5-tab');
                if (this.sageCodeSub != null) this.sageCodeSub.unsubscribe();
            }, error => {
                console.log(error);
                if (this.sageCodeSub != null) this.sageCodeSub.unsubscribe();
            });
        }
    }

    changeCtcDb() {
        let index = this.allActivation.findIndex(i => i.activationID == this.actualId);
        if (this.newCtc.status == "VALID") {
            // Met en langue celle du navigateur
            this.temp.login = this.newCtc.value.ctcLogin.trim();
            this.temp.password = this.newCtc.value.ctcPassword.trim();
            this.temp.language = this.newCtc.value.ctcLanguage;

            this.ctcConnectionSub = this.api.logInCtcReallocation(this.temp, this.actualId).subscribe(data => {
                if (data == "true") {
                    this.closeModal("ctcModal");
                    this.allActivation[index].ctcLogin = this.invoiceForm.value.ctcLogin;
                    this.openSnackBar("Réaffectation du ctc bien effectuée", "Fermer");
                    this.refreshTab();
                    this.errorCtcInput = false;
                    this.errorCtcAccount = false;
                } else if (data == "badAccount") {
                    this.errorCtcInput = false;
                    this.errorCtcAccount = true;
                }
                if (this.ctcConnectionSub != null) this.ctcConnectionSub.unsubscribe();
            },
                error => {
                    console.log(error);
                    this.newCtc.markAsTouched();
                    if (this.ctcConnectionSub != null) this.ctcConnectionSub.unsubscribe();
                })
        } else {
            this.newCtc.markAsTouched();
            this.errorCtcInput = true;
            this.errorCtcAccount = false;
        }
    }

    resetCtcError() {
        this.errorCtcInput = false;
        this.errorCtcAccount = false;
    }

    sleepyModal(activId: number) {
        this.actualId = activId;
        let modal = document.getElementById("sleepyModal");
        modal.style.display = "block";
    }

    setSleepyActivation() {
        this.sleepySub = this.api.setSleepyActivation(this.actualId).subscribe(data => {
            if (data == true) {
                this.refreshTab();
                this.closeModal("sleepyModal");
            }
            if (this.sleepySub != null) this.sleepySub.unsubscribe();
        }, error => {
            console.log(error);
            if (this.sleepySub != null) this.sleepySub.unsubscribe();
        })
    }

    detailRow(activId: number, keepOld: boolean = false, callback?: () => void) {
        this.actualId = activId;
        this.detailInfoSub = this.api.infoDetailActivation(activId).subscribe(data => {
            //console.log(data);
            this.scaleFull = data;
            if (!keepOld)
                this.oldScaleFull = JSON.parse(JSON.stringify(data));
            //this.activationDetailSource = new MatTableDataSource(this.activationDetail);
            //this.displayedColumnsDetail = this.displayedColumnsDetailS1;
            if (callback)
                callback();
            let modal = document.getElementById("detailRow");
            modal.style.display = "block";
        });

    }

    deleteRowActivation(activationID: number) {
        console.log("activationID: " + activationID);

        this.deleteSub = this.api.deleteActivation(activationID).subscribe(data => {
            for (var i = 0; i < this.scaleFull.activationFull.length; i++) {
                if (this.scaleFull.activationFull[i].a_activationID == activationID) {
                    this.scaleFull.activationFull[i].a_status = 19;
                    for (var j = 0; j < this.scaleFull.activationFull[i].billingFull.length; j++) {
                        this.scaleFull.activationFull[i].billingFull[j].b_transStatus = 19;
                    }
                    break;
                }
            }

            var activation = document.getElementsByClassName("activation-" + activationID);
            if (activation != null) {
                for (var i = 0; i < activation.length; i++) {
                    activation[i].classList.add("deleted-opacity");
                }
            }
        });
    }

    deleteRowBilling(billingID: number, activationID: number) {
    /* ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- */console.log("billingID: " + billingID);



        this.deleteSub = this.api.deleteBilling(billingID).subscribe(data => {
            for (var i = 0; i < this.scaleFull.activationFull.length; i++) {
                var a_statusFullBillingDelete = 1;
                if (this.scaleFull.activationFull[i].a_activationID == activationID) {
                    for (var j = 0; j < this.scaleFull.activationFull[i].billingFull.length; j++) {
                        if (this.scaleFull.activationFull[i].billingFull[j].b_billingID == billingID) {
                            this.scaleFull.activationFull[i].billingFull[j].b_transStatus = 19;
                        }
                        if (this.scaleFull.activationFull[i].billingFull[j].b_transStatus == 2) {
                            a_statusFullBillingDelete = 0;
                        }
                    }
                    this.scaleFull.activationFull[i].a_statusFullBillingDelete = a_statusFullBillingDelete;
                    break;
                }
            }

            var billing = document.getElementsByClassName("billing-" + billingID);
            if (billing != null) {
                for (var i = 0; i < billing.length; i++) {
                    billing[i].classList.add("deleted-opacity");
                }
            }
        });
    }

    sortScale(sort: Sort, status: string) {
        var data = this.activationLst;
        Constants.sortScale(sort, status, data)

        this.activationLst = data.slice();
        this.activationSource = new MatTableDataSource(this.activationLst);
    }


    sendCodeActivationLicence(billingID: number, activationID: number) {
        this.activationCodeSub = this.api.sendCodeActivationLicence(activationID, billingID).subscribe(data => {
            if (data) {
                let modal = document.getElementById("mailCodeActivation");
                modal.style.display = "block";
            }
        });
    }

    changeFlagConserverRecherche() {
        this.conserverRecherche = !this.conserverRecherche;
    }

    //sortActivationDetail(sort: Sort, status: string) {
    //  var data = this.activationDetail;
    //  Constants.sortScale(sort, status, data)

    //  this.activationDetail = data.slice();
    //  this.activationDetailSource = new MatTableDataSource(this.activationDetail);
    //  this.displayedColumnsDetail = this.displayedColumnsDetailS1;
    //}

    deleteScaleLicenceDates(scaleID: number) {
        let modal = document.getElementById("confirmationModal");

        this.confirmationModalCB = () => {
            this.deleteScaleLicenceDatesSub = this.api.deleteScaleLicenceDates(scaleID).subscribe(data => {
                if (data) {
                    this.detailRow(this.actualId, true);
                }
                if (this.deleteScaleLicenceDatesSub != null) this.deleteScaleLicenceDatesSub.unsubscribe();
            }, error => {
                if (this.deleteScaleLicenceDatesSub != null) this.deleteScaleLicenceDatesSub.unsubscribe();
            });

            modal.style.display = 'none';
        };

        modal.style.display = 'block';
    }

    editActivationCTC(actI: number) {
        const act = this.scaleFull.activationFull[actI];

        this.getAlternativeCTCSub = this.api.getAlternativeCTC(act.a_ctc).subscribe(data => {
            (act as any).a_ctc__edit = act.a_ctc;
            (act as any).a_ctc__options = data;
            if (this.getAlternativeCTCSub != null) this.getAlternativeCTCSub.unsubscribe();
        }, error => {
            if (this.getAlternativeCTCSub != null) this.getAlternativeCTCSub.unsubscribe();
        });
    }

    rewindActivationCTC(actI: number) {
        const act = this.scaleFull.activationFull[actI];
        const oldAct = this.oldScaleFull.activationFull[actI];

        this.getAlternativeCTCSub = this.api.getAlternativeCTC(act.a_ctc).subscribe(data => {
            (act as any).a_ctc__edit = oldAct.a_ctc;
            (act as any).a_ctc__options = data;
            this.validateActivationCTC(actI);
            if (this.getAlternativeCTCSub != null) this.getAlternativeCTCSub.unsubscribe();
        }, error => {
            if (this.getAlternativeCTCSub != null) this.getAlternativeCTCSub.unsubscribe();
        });
    }

    validateActivationCTC(actI: number) {
        let modal = document.getElementById("confirmationModal");

        this.confirmationModalCB = () => {
            const act = this.scaleFull.activationFull[actI];

            this.changeActivationCTCSub = this.api.changeActivationCTC(act.a_activationID, (act as any).a_ctc__edit).subscribe(data => {
                if (data) {
                    this.detailRow(this.actualId, true);
                    //act.a_ctc = (act as any).a_ctc__edit;
                    //this.cancelActivationCTC(actI);
                }
                if (this.changeActivationCTCSub != null) this.changeActivationCTCSub.unsubscribe();
            }, error => {
                if (this.changeActivationCTCSub != null) this.changeActivationCTCSub.unsubscribe();
            });

            modal.style.display = 'none';
        };

        modal.style.display = 'block';
    }

    cancelActivationCTC(actI: number) {
        const act = this.scaleFull.activationFull[actI];
        (act as any).a_ctc__edit = undefined;
        (act as any).a_ctc__options = undefined;
    }

    editActivationUserFull(actI: number) {
        const act = this.scaleFull.activationFull[actI];

        this.getAllUsersSub = this.api.getAllUsers().subscribe(data => {
            (act as any).userFull.u_userid__edit = act.userFull.u_userid;
            (act as any).userFull.u_userid__options = (act as any).userFull.u_userid__filteredOptions = data;
            if (this.getAllUsersSub != null) this.getAllUsersSub.unsubscribe();
        }, error => {
            if (this.getAllUsersSub != null) this.getAllUsersSub.unsubscribe();
        });
    }

    rewindActivationUserFull(actI: number) {
        const act = this.scaleFull.activationFull[actI];
        const oldAct = this.oldScaleFull.activationFull[actI];

        this.getAllUsersSub = this.api.getAllUsers().subscribe(data => {
            (act as any).userFull.u_userid__edit = oldAct.userFull.u_userid;
            (act as any).userFull.u_userid__options = (act as any).userFull.u_userid__filteredOptions = data;
            this.validateActivationUserFull(actI);
            if (this.getAllUsersSub != null) this.getAllUsersSub.unsubscribe();
        }, error => {
            if (this.getAllUsersSub != null) this.getAllUsersSub.unsubscribe();
        });
    }

    validateActivationUserFull(actI: number) {
        let modal = document.getElementById("confirmationModal");

        const act = this.scaleFull.activationFull[actI];
        if (!(act as any).userFull.u_userid__edit)
            return;

        this.confirmationModalCB = () => {
            if ((act as any).userFull.u_userid__edit)
                this.changeActivationUserFullSub = this.api.changeActivationUserFull(act.a_activationID, (act as any).userFull.u_userid__edit, false).subscribe(data => {
                    if (data) {
                        this.detailRow(this.actualId, true);
                    }
                    if (this.changeActivationUserFullSub != null) this.changeActivationUserFullSub.unsubscribe();
                }, error => {
                    if (this.changeActivationUserFullSub != null) this.changeActivationUserFullSub.unsubscribe();
                });

            modal.style.display = 'none';
        };

        modal.style.display = 'block';
    }

    cancelActivationUserFull(actI: number) {
        const act = this.scaleFull.activationFull[actI];
        (act as any).userFull.u_userid__edit = undefined;
        (act as any).userFull.u_userid__options = undefined;
        (act as any).userFull.u_userid__filteredOptions = undefined;
    }

    duplicateActivationUserFull(actI: number, isPayor: boolean) {
        let modal = document.getElementById("confirmationModal");

        this.confirmationModalCB = () => {
            const act = this.scaleFull.activationFull[actI];

            this.duplicateActivationUserFullSub = this.api.duplicateActivationUserFull(act.a_activationID, isPayor).subscribe(data => {
                if (data) {
                    this.detailRow(this.actualId, true, () => {
                        (this.scaleFull.activationFull[actI][isPayor ? 'payorFull' : 'userFull'] as any).duplicated = true;
                    });
                }
                if (this.duplicateActivationUserFullSub != null) this.duplicateActivationUserFullSub.unsubscribe();
            }, error => {
                if (this.duplicateActivationUserFullSub != null) this.duplicateActivationUserFullSub.unsubscribe();
            });

            modal.style.display = 'none';
        };

        modal.style.display = 'block';
    }

    filterActivationUserFullOptions(actI: number, isPayor: boolean, inputValue: string) {
        const act = this.scaleFull.activationFull[actI];
        const usr = (act as any)[isPayor ? 'payorFull' : 'userFull'];
        if (!usr[(isPayor ? 'p_userid' : 'u_userid') + '__options'])
            return;

        const filterValue = inputValue.toLowerCase();
        usr[(isPayor ? 'p_userid' : 'u_userid') + '__filteredOptions'] = usr[(isPayor ? 'p_userid' : 'u_userid') + '__options'].filter(o => this.displayActivationUserFullOption(actI, isPayor)(o.userID).toLowerCase().includes(filterValue));
    }

    displayActivationUserFullOption(actI: number, isPayor: boolean): (any) => string | null {
        return (userID) => {
            if (!userID)
                return null;

            const act = this.scaleFull.activationFull[actI];
            const usr = (act as any)[isPayor ? 'payorFull' : 'userFull'];
            const opt = usr[(isPayor ? 'p_userid' : 'u_userid') + '__options'].find(opt => opt.userID === userID);

            return opt.firstname + ' ' + opt.name + ' (' + opt.userID + ')';
        }
    }

    editActivationPayorFull(actI: number) {
        const act = this.scaleFull.activationFull[actI];

        this.getAllUsersSub = this.api.getAllUsers().subscribe(data => {
            (act as any).payorFull.p_userid__edit = act.payorFull.p_userid;
            (act as any).payorFull.p_userid__options = (act as any).payorFull.p_userid__filteredOptions = data;
            if (this.getAllUsersSub != null) this.getAllUsersSub.unsubscribe();
        }, error => {
            if (this.getAllUsersSub != null) this.getAllUsersSub.unsubscribe();
        });
    }

    rewindActivationPayorFull(actI: number) {
        const act = this.scaleFull.activationFull[actI];
        const oldAct = this.oldScaleFull.activationFull[actI];

        this.getAllUsersSub = this.api.getAllUsers().subscribe(data => {
            (act as any).payorFull.p_userid__edit = oldAct.payorFull.p_userid;
            (act as any).payorFull.p_userid__options = (act as any).payorFull.p_userid__filteredOptions = data;
            this.validateActivationPayorFull(actI);
            if (this.getAllUsersSub != null) this.getAllUsersSub.unsubscribe();
        }, error => {
            if (this.getAllUsersSub != null) this.getAllUsersSub.unsubscribe();
        });
    }

    validateActivationPayorFull(actI: number) {
        let modal = document.getElementById("confirmationModal");

        const act = this.scaleFull.activationFull[actI];
        if (!(act as any).payorFull.p_userid__edit)
            return;

        this.confirmationModalCB = () => {
            if ((act as any).payorFull.p_userid__edit)
                this.changeActivationUserFullSub = this.api.changeActivationUserFull(act.a_activationID, (act as any).payorFull.p_userid__edit, true).subscribe(data => {
                    if (data) {
                        this.detailRow(this.actualId, true);
                    }
                    if (this.changeActivationUserFullSub != null) this.changeActivationUserFullSub.unsubscribe();
                }, error => {
                    if (this.changeActivationUserFullSub != null) this.changeActivationUserFullSub.unsubscribe();
                });

            modal.style.display = 'none';
        };

        modal.style.display = 'block';
    }

    cancelActivationPayorFull(actI: number) {
        const act = this.scaleFull.activationFull[actI];
        (act as any).payorFull.p_userid__edit = undefined;
        (act as any).payorFull.p_userid__options = undefined;
        (act as any).payorFull.p_userid__filteredOptions = undefined;
    }

    editActivationCompanyUserFull(actI: number) {
        const act = this.scaleFull.activationFull[actI];

        this.getAllCompaniesSub = this.api.getAllCompanies().subscribe(data => {
            (act as any).companyUserFull.c_companyID__edit = act.companyUserFull.c_companyID;
            (act as any).companyUserFull.c_companyID__options = (act as any).companyUserFull.c_companyID__filteredOptions = data;
            if (this.getAllCompaniesSub != null) this.getAllCompaniesSub.unsubscribe();
        }, error => {
            if (this.getAllCompaniesSub != null) this.getAllCompaniesSub.unsubscribe();
        });
    }

    rewindActivationCompanyUserFull(actI: number) {
        const act = this.scaleFull.activationFull[actI];
        const oldAct = this.oldScaleFull.activationFull[actI];

        this.getAllCompaniesSub = this.api.getAllCompanies().subscribe(data => {
            (act as any).companyUserFull.c_companyID__edit = oldAct.companyUserFull.c_companyID;
            (act as any).companyUserFull.c_companyID__options = (act as any).companyUserFull.c_companyID__filteredOptions = data;
            this.validateActivationCompanyUserFull(actI);
            if (this.getAllCompaniesSub != null) this.getAllCompaniesSub.unsubscribe();
        }, error => {
            if (this.getAllCompaniesSub != null) this.getAllCompaniesSub.unsubscribe();
        });
    }

    validateActivationCompanyUserFull(actI: number) {
        let modal = document.getElementById("confirmationModal");

        const act = this.scaleFull.activationFull[actI];
        if (!(act as any).companyUserFull.c_companyID__edit)
            return;

        this.confirmationModalCB = () => {
            if ((act as any).companyUserFull.c_companyID__edit)
                this.changeActivationCompanyUserFullSub = this.api.changeActivationCompanyUserFull(act.a_activationID, (act as any).companyUserFull.c_companyID__edit, false).subscribe(data => {
                    if (data) {
                        this.detailRow(this.actualId, true);
                    }
                    if (this.changeActivationCompanyUserFullSub != null) this.changeActivationCompanyUserFullSub.unsubscribe();
                }, error => {
                    if (this.changeActivationCompanyUserFullSub != null) this.changeActivationCompanyUserFullSub.unsubscribe();
                });

            modal.style.display = 'none';
        };

        modal.style.display = 'block';
    }

    cancelActivationCompanyUserFull(actI: number) {
        const act = this.scaleFull.activationFull[actI];
        (act as any).companyUserFull.c_companyID__edit = undefined;
        (act as any).companyUserFull.c_companyID__options = undefined;
        (act as any).companyUserFull.c_companyID__filteredOptions = undefined;
    }

    duplicateActivationCompanyUserFull(actI: number, isPayor: boolean) {
        let modal = document.getElementById("confirmationModal");

        this.confirmationModalCB = () => {
            const act = this.scaleFull.activationFull[actI];

            this.duplicateActivationCompanyUserFullSub = this.api.duplicateActivationCompanyUserFull(act.a_activationID, isPayor).subscribe(data => {
                if (data) {
                    this.detailRow(this.actualId, true);
                }
                if (this.duplicateActivationCompanyUserFullSub != null) this.duplicateActivationCompanyUserFullSub.unsubscribe();
            }, error => {
                if (this.duplicateActivationCompanyUserFullSub != null) this.duplicateActivationCompanyUserFullSub.unsubscribe();
            });

            modal.style.display = 'none';
        };

        modal.style.display = 'block';
    }

    filterActivationCompanyUserFullOptions(actI: number, isPayor: boolean, inputValue: string) {
        const act = this.scaleFull.activationFull[actI];
        const cmp = (act as any)[isPayor ? 'companyPayorFull' : 'companyUserFull'];
        if (!cmp[(isPayor ? 'cPayor_companyID' : 'c_companyID') + '__options'])
            return;

        const filterValue = inputValue.toLowerCase();
        cmp[(isPayor ? 'cPayor_companyID' : 'c_companyID') + '__filteredOptions'] = cmp[(isPayor ? 'cPayor_companyID' : 'c_companyID') + '__options'].filter(o => this.displayActivationCompanyUserFullOption(actI, isPayor)(o.companyId).toLowerCase().includes(filterValue));
    }

    displayActivationCompanyUserFullOption(actI: number, isPayor: boolean): (any) => string | null {
        return (companyId) => {
            if (!companyId)
                return null;

            const act = this.scaleFull.activationFull[actI];
            const cmp = (act as any)[isPayor ? 'companyPayorFull' : 'companyUserFull'];
            const opt = cmp[(isPayor ? 'cPayor_companyID' : 'c_companyID') + '__options'].find(opt => opt.companyId === companyId);

            return opt.socialReason + ' (' + opt.companyId + ')';
        }
    }

    editActivationCompanyPayorFull(actI: number) {
        const act = this.scaleFull.activationFull[actI];

        this.getAllCompaniesSub = this.api.getAllCompanies().subscribe(data => {
            (act as any).companyPayorFull.cPayor_companyID__edit = act.companyPayorFull.cPayor_companyID;
            (act as any).companyPayorFull.cPayor_companyID__options = (act as any).companyPayorFull.cPayor_companyID__options = data;
            if (this.getAllCompaniesSub != null) this.getAllCompaniesSub.unsubscribe();
        }, error => {
            if (this.getAllCompaniesSub != null) this.getAllCompaniesSub.unsubscribe();
        });
    }

    rewindActivationCompanyPayorFull(actI: number) {
        const act = this.scaleFull.activationFull[actI];
        const oldAct = this.oldScaleFull.activationFull[actI];

        this.getAllCompaniesSub = this.api.getAllCompanies().subscribe(data => {
            (act as any).companyPayorFull.cPayor_companyID__edit = oldAct.companyPayorFull.cPayor_companyID;
            (act as any).companyPayorFull.cPayor_companyID__options = (act as any).companyPayorFull.cPayor_companyID__options = data;
            this.validateActivationCompanyPayorFull(actI);
            if (this.getAllCompaniesSub != null) this.getAllCompaniesSub.unsubscribe();
        }, error => {
            if (this.getAllCompaniesSub != null) this.getAllCompaniesSub.unsubscribe();
        });
    }

    validateActivationCompanyPayorFull(actI: number) {
        let modal = document.getElementById("confirmationModal");

        const act = this.scaleFull.activationFull[actI];
        if (!(act as any).companyPayorFull.cPayor_companyID__edit)
            return;

        this.confirmationModalCB = () => {
            if ((act as any).companyPayorFull.cPayor_companyID__edit)
                this.changeActivationUserFullSub = this.api.changeActivationCompanyUserFull(act.a_activationID, (act as any).companyPayorFull.cPayor_companyID__edit, true).subscribe(data => {
                    if (data) {
                        this.detailRow(this.actualId, true);
                    }
                    if (this.changeActivationUserFullSub != null) this.changeActivationUserFullSub.unsubscribe();
                }, error => {
                    if (this.changeActivationUserFullSub != null) this.changeActivationUserFullSub.unsubscribe();
                });

            modal.style.display = 'none';
        };

        modal.style.display = 'block';
    }

    cancelActivationCompanyPayorFull(actI: number) {
        const act = this.scaleFull.activationFull[actI];
        (act as any).companyPayorFull.cPayor_companyID__edit = undefined;
        (act as any).companyPayorFull.cPayor_companyID__options = undefined;
        (act as any).companyPayorFull.cPayor_companyID__filteredOptions = undefined;
    }

    editActivationSubProp(actI: number, container: string, property: string) {
        const act = this.scaleFull.activationFull[actI];

        (act as any)[container][property + '__edit'] = act[container][property];
    }

    rewindActivationSubProp(actI: number, container: string, property: string, usedId: number) {
        const act = this.scaleFull.activationFull[actI];
        const oldAct = this.oldScaleFull.activationFull[actI];

        (act as any)[container][property + '__edit'] = oldAct[container][property];
        this.validateActivationSubProp(actI, container, property, usedId);
    }

    validateActivationSubProp(actI: number, container: string, property: string, usedId: number) {
        let modal = document.getElementById("confirmationModal");

        this.confirmationModalCB = () => {
            const act = this.scaleFull.activationFull[actI];

            this.changeActivationSubPropSub = this.api.changeActivationSubProp(usedId, container, property, (act as any)[container][property + '__edit']).subscribe(data => {
                if (data) {
                    this.detailRow(this.actualId, true);
                    //act[container][property] = (act as any)[container][property + '__edit'];
                    //this.cancelActivation(actI, container, property);
                }
                if (this.changeActivationSubPropSub != null) this.changeActivationSubPropSub.unsubscribe();
            }, error => {
                if (this.changeActivationSubPropSub != null) this.changeActivationSubPropSub.unsubscribe();
            });

            modal.style.display = 'none';
        };

        modal.style.display = 'block';
    }

    cancelActivationSubProp(actI: number, container: string, property: string) {
        const act = this.scaleFull.activationFull[actI];
        (act as any)[container][property + '__edit'] = undefined;
    }

    openMigrationModal() {
        let modal = document.getElementById("migrationModal");
        modal.style.display = 'block';
    }

    migrationModalCB() {
        if (this.migration.status == "VALID") {
            let chosenBalance = this.migration.value.balance;
            let chosenActivations = this.migration.value.activations;

            this.sendMigrationRequestSub = this.api.sendMigrationRequest(chosenBalance, chosenActivations).subscribe(data => {
                if (data) {
                    this.pendingMigration = data;
                    let modal = document.getElementById("confirmCodeModal");
                    modal.style.display = 'block';
                }
                if (this.sendMigrationRequestSub != null) this.sendMigrationRequestSub.unsubscribe();
            }, error => {
                this.migration.markAsTouched();
                if (this.sendMigrationRequestSub != null) this.sendMigrationRequestSub.unsubscribe();
            });
        } else {
            this.migration.markAsTouched();
        }
    }

    confirmCodeModalCB() {
        if (this.migrationConfirm.status == "VALID") {
            let code = this.migrationConfirm.value.code;

            this.resolveMigrationRequestSub = this.api.resolveMigrationRequest(this.pendingMigration, code).subscribe(data => {
                if (data) {
                    this.badCode = false;

                    let modal = document.getElementById("confirmCodeModal");
                    modal.style.display = 'none';
                    modal = document.getElementById("migrationModal");
                    modal.style.display = 'none';

                    this.migration.reset();
                    this.migrationConfirm.reset();

                    this.refreshTab();
                    this.detailRow(this.actualId, false);
                }
                else {
                    this.badCode = true;
                    this.migrationConfirm.controls.code.setErrors({ invalid: true })
                }

                if (this.resolveMigrationRequestSub != null) this.resolveMigrationRequestSub.unsubscribe();
            }, error => {
                this.migrationConfirm.markAsTouched();
                if (this.resolveMigrationRequestSub != null) this.resolveMigrationRequestSub.unsubscribe();
            });
        } else {
            this.migrationConfirm.markAsTouched();
        }
    }

    addBilling(activationId: number) {
        this.activationToAddBillingTo = activationId;
        this.resetAddBillingForm();
        let modal = document.getElementById("addBillingModal");
        modal.style.display = 'block';
    }

    getUsableStatuses() {
        const allowed = [StatusBillingType.PENDING, StatusBillingType.ACCEPTED, StatusBillingType.WAITING_AUTHORISATION_PAYMENT_BY_VIREMENT];

        let finalArray = [];
        for (let a of allowed) {
            finalArray.push({ key: StatusBillingType[a], value: a})
        }

        return finalArray;
    }

    updateSocialReasonLiv() {
        this.addBillingForm.controls.socialReason.setValue(this.addBillingForm.value.socialReasonFact);
    }

    updateAddressLiv() {
        this.addBillingForm.controls.address.setValue(this.addBillingForm.value.addressFact);
    }

    updatePostalCodeLiv() {
        this.addBillingForm.controls.postalCode.setValue(this.addBillingForm.value.postalCodeFact);
    }

    updateCityLiv() {
        this.addBillingForm.controls.city.setValue(this.addBillingForm.value.cityFact);
    }

    updateCountryFLiv() {
        this.addBillingForm.controls.countryF.setValue(this.addBillingForm.value.countryFFact);
    }

    copyFacturationData(value: boolean) {
        this.addBillingForm.controls.socialReason.setValue(value ? this.addBillingForm.value.socialReasonFact : '');
        this.addBillingForm.controls.address.setValue(value ? this.addBillingForm.value.addressFact : '');
        this.addBillingForm.controls.postalCode.setValue(value ? this.addBillingForm.value.postalCodeFact : '');
        this.addBillingForm.controls.city.setValue(value ? this.addBillingForm.value.cityFact : '');
        this.addBillingForm.controls.countryF.setValue(value ? this.addBillingForm.value.countryFFact : '');

        if (value) {
            this.addBillingForm.controls.socialReason.disable();
            this.addBillingForm.controls.address.disable();
            this.addBillingForm.controls.postalCode.disable();
            this.addBillingForm.controls.city.disable();
            this.addBillingForm.controls.countryF.disable();
        }
        else {
            this.addBillingForm.controls.socialReason.enable();
            this.addBillingForm.controls.address.enable();
            this.addBillingForm.controls.postalCode.enable();
            this.addBillingForm.controls.city.enable();
            this.addBillingForm.controls.countryF.enable();
        }
    }

    updateTvaCheck() {
        if (this.addBillingForm.value.countryFFact) {
            let tvaRegEx = Constants.countries.find(c => c.name == this.addBillingForm.value.countryFFact).tvaRegEx;
            if (tvaRegEx != "") {
                this.addBillingForm.controls['tva'].setValidators([Validators.required, Validators.pattern(Constants.countries.find(c => c.name.toLowerCase() == this.addBillingForm.value.countryFFact.toLowerCase()).tvaRegEx)]);
                this.addBillingForm.controls['tva'].updateValueAndValidity();
                this.tvaCkeck = true;
            } else {
                this.addBillingForm.controls['tva'].clearValidators();
                this.addBillingForm.controls['tva'].updateValueAndValidity();
                this.addBillingForm.controls["tva"].setValue('');
                this.tvaCkeck = false;
            }

            let countryFact: string = this.addBillingForm.value.countryFFact;
            if (countryFact.toLowerCase() == "france") {
                this.tauxTva = 20;
            }
            else {
                this.tauxTva = 0;
            }
        }
    }

    addBillingModalCB(noMail: boolean) {
        if (this.addBillingForm.status == "VALID") {
            this.noMailOnNewBilling = noMail;

            let modal = document.getElementById("confirmAddBillingModal");
            modal.style.display = 'block';
        } else {
            this.addBillingForm.markAsTouched();
        }
    }

    confirmAddBillingModalCB() {
        let qty: number = this.addBillingForm.value.licenseAmount;
        this.products[0].qte = qty;

        let price = this.products.reduce((prev, curr) => prev + (curr.amountP * curr.qte), 0);
        let priceTTC = Math.round(price * (100 + this.tauxTva)) / 100;

        let bill: IBillingV1 = new IBillingV1();
        bill.billingInfo = '';
        bill.nbProducts = this.products.length;
        bill.amountTotal = priceTTC;
        bill.activationID = this.activationToAddBillingTo;
        bill.currency = 978;
        bill.paymentCB = this.addBillingForm.value.isCb;

        bill.login = this.addBillingForm.value.login;
        bill.unisiteCode = this.addBillingForm.value.unisiteCode;
        bill.transStatus = this.addBillingForm.value.status;

        bill.lstBillDetails = [];
        for (let i in this.products) {
            let billDetail: IBillingDetailV1 = new IBillingDetailV1();
            billDetail.productId = this.products[i].productID;
            billDetail.qty = this.products[i].qte;

            bill.lstBillDetails.push(billDetail);
        }

        let adrFact: IAdresseV1 = new IAdresseV1();
        let adrLiv: IAdresseV1 = new IAdresseV1();
        adrFact.socialReason = this.addBillingForm.value.socialReasonFact;
        adrFact.address = this.addBillingForm.value.addressFact;
        adrFact.postalCode = this.addBillingForm.value.postalCodeFact;
        adrFact.city = this.addBillingForm.value.cityFact;
        adrFact.country = this.addBillingForm.value.countryFFact;
        adrFact.siret = this.addBillingForm.value.siret ?? "";
        adrFact.tvaIntra = this.addBillingForm.value.tva ?? "";
        adrFact.login = this.addBillingForm.value.login;
        adrFact.isIsland = this.addBillingForm.value.island ? true : false;
        adrFact.type = 1;
        bill.adresseFacturation = adrFact;

        adrLiv.socialReason = this.addBillingForm.controls.socialReason.value;
        adrLiv.address = this.addBillingForm.controls.address.value;
        adrLiv.postalCode = this.addBillingForm.controls.postalCode.value;
        adrLiv.city = this.addBillingForm.controls.city.value;
        adrLiv.country = this.addBillingForm.controls.countryF.value;
        adrLiv.siret = this.addBillingForm.value.siret ?? "";
        adrLiv.tvaIntra = this.addBillingForm.value.tva ?? "";
        adrLiv.login = this.addBillingForm.controls.login.value;
        adrLiv.isIsland = this.addBillingForm.value.island ? true : false;
        adrLiv.type = 2;
        bill.adresseLivraison = adrLiv;

        bill.email = this.addBillingForm.value.mail;
        bill.language = 'fr';

        if (this.addBillingForm.value.island)
            bill.isQuote = true;

        this.addBillingToActivationSub = this.api.addBillingToActivation(bill, this.noMailOnNewBilling).subscribe(data => {
            let modal = document.getElementById("confirmAddBillingModal");
            modal.style.display = 'none';

            if (data) {
                modal = document.getElementById("addBillingModal");
                modal.style.display = 'none';

                this.addBillingForm.reset();

                this.detailRow(this.actualId, false);
            }

            if (this.addBillingToActivationSub != null) this.addBillingToActivationSub.unsubscribe();
        }, error => {
            this.addBillingForm.markAsTouched();
            if (this.addBillingToActivationSub != null) this.addBillingToActivationSub.unsubscribe();
        });
    }

    resetAddBillingForm() {
        this.addBillingForm.setValue({
            licenseAmount: 1,
            status: StatusBillingType.WAITING_AUTHORISATION_PAYMENT_BY_VIREMENT,
            isCb: false,
            unisiteCode: null,
            login: null,

            socialReasonFact: '',
            addressFact: '',
            postalCodeFact: '',
            cityFact: '',
            countryFFact: '',
            siret: '',
            tva: '',

            socialReason: '',
            address: '',
            postalCode: '',
            city: '',
            countryF: '',
            island: false,

            mail: ''
        });

        this.getBillingEmail();
    }

    getBillingEmail() {
        this.emailSub = this.api.getEmailCommandByLogin().subscribe(data => {
            this.addBillingForm.controls.mail.setValue(data);
            if (this.emailSub != null) this.emailSub.unsubscribe();
        }, error => {
            if (this.emailSub != null) this.emailSub.unsubscribe();
        });
    }


}
